export enum Condition {
  NORMAL = 'normal',
  ATTENTION = 'attention',
  PROBLEM = 'problem',
  HIGH_FAULT_PROBABILITY = 'prob-20',
  MID_FAULT_PROBABILITY = 'prob-15',
  LOW_FAULT_PROBABILITY = 'prob-11'
}
